import clearBlocksHtml from './clear-blocks-html';
import clearPageTemplatesHtml from './clear-page-templates-html';
import clearGlobalsHtml from './clear-globals-html';
import setMainLocale from './set-main-locale';
import addLocale from './add-locale';
import removeLocale from './remove-locale';
import saveMainLocale from './save-main-locale';
import setSupportedLocales from './set-supported-locales';

export default {
  clearBlocksHtml,
  clearPageTemplatesHtml,
  clearGlobalsHtml,
  setMainLocale,
  addLocale,
  removeLocale,
  saveMainLocale,
  setSupportedLocales,
};
